var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"ofp-chart-wrapper",style:({
  height: ((Math.max(400, ((_vm.topNumber | 0) * 25) + 85)) + "px")
})},[_c('div',{staticClass:"ofp-chart-container"},[_c('e-chart',{ref:"ofp-chart",on:{"initialized":_vm.onOFPChartInitialized,"destroy":_vm.onOFPChartDestroy}})],1),_vm._v(" "),_c('div',{staticClass:"iofp-chart-container"},[_c('e-chart',{ref:"iofp-chart"})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-874604e2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Data/OFPChart.vue
// module id = null
// module chunks = 